<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pZ7f7K/tc-custom/9780738774886.jpg?1741985490230" alt="This image is the cover for the book Llewellyn's Little Book of Witchcraft"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Llewellyn's Little Book of Witchcraft
      </h1>
      <p class="bookDescription body article font2">
        <p>Brimming with nearly seventy spells, tips, and activities, this illustrated book helps you take new steps on your personal journey into witchcraft. Award-winning author Deborah Blake teaches you how to build an altar, use divination tools, invoke deities, and much more. Covering a wide range of magical goals, this little book will help you improve your relationships, deepen your connection to nature, and live a successful, enchanted life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Blake
      </h2>
      
      <p class="authorDescription body article"><P><B>Deborah Blake</B> is the author of seventeen books on modern Witchcraft, including <I>The Eclectic Witch's Book of Shadows</I>, <I>The Little Book of Cat Magic</I>, and <I>Llewellyn's Little Book of Spellcraft</I>, as well as the acclaimed <I>Everyday Witch Tarot</I>, <I>Everyday Witch Oracle</I>, and <I>Everyday Witch’s Familiars Oracle</I>. She has also written three paranormal romance and urban fantasy series for Berkley, and as well as a cozy mystery series about a run-down pet rescue. Deborah lives in a 140-year-old farmhouse in upstate New York with numerous cats who supervise all her activities, both magical and mundane. She can be found at DeborahBlakeAuthor.com.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9b6a40c6